import React from "react";
import { useNavigate } from "react-router-dom";
import { Heading } from "../../../design/heading";
import { Button } from "../../../design/button";
import { useAuth } from "../../../contexts/AuthContext";
import { CalendarIcon, CheckIcon } from "@heroicons/react/20/solid";
import { Text } from "../../../design/text";
import { Card } from "../../../design/card";

const CalendarStep: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const onNylasButtonClick = () => {
    if (!user) return;
    const client_id = process.env.REACT_APP_NYLAS_CLIENT_ID;
    const redirect_uri = origin + "/callback/nylas";
    const response_type = "code";
    const prompt = "detect";
    const url = `https://api.us.nylas.com/v3/connect/auth?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=${response_type}&prompt=${prompt}&login_hint=${user.email}`;
    window.open(url, "_blank");
  };

  const handleBack = () => {
    navigate("/onboarding/address");
  };

  const handleSkip = () => {
    navigate("/onboarding/subscription");
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      {/* Header */}
      <div className="space-y-2 text-center">
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-blue-100 rounded-full dark:bg-blue-900/30">
            <CalendarIcon className="w-8 h-8 text-blue-600 dark:text-blue-400" />
          </div>
        </div>
        <Heading>Integrate Your Business Calendar</Heading>
        <Text className="text-lg text-gray-600 dark:text-gray-400">
          Connect your calendar for seamless scheduling
        </Text>
      </div>

      {/* Benefits Card */}
      <Card>
        <div className="space-y-4">
          <Text className="font-semibold text-gray-900 dark:text-white">
            What you'll get:
          </Text>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <CheckIcon className="w-6 h-6 dark:text-white" />
              <Text className="text-sm text-gray-700 dark:text-gray-300">
                Automatic sync of appointments and events
              </Text>
            </div>
            <div className="flex items-start gap-3">
            <CheckIcon className="w-6 h-6 dark:text-white" />
            <Text className="text-sm text-gray-700 dark:text-gray-300">
                Supervisors are automatically invited as participants
              </Text>
            </div>
            <div className="flex items-start gap-3">
            <CheckIcon className="w-6 h-6 dark:text-white" />
            <Text className="text-sm text-gray-700 dark:text-gray-300">
                Better team schedule management
              </Text>
            </div>
          </div>
        </div>
      </Card>

      {/* Info Card */}
      <Card className="border-blue-200 bg-blue-50 dark:bg-blue-900/20 dark:border-blue-800">
        <div className="flex items-start gap-3">
          <span className="flex-shrink-0 text-xl">ℹ️</span>
          <div className="text-sm text-gray-700 dark:text-gray-300">
            <Text>
              Visit Proof integrates with your business calendar to help you manage your team's schedule.
              Appointments are synced and supervisors are invited as participants after each visit is scheduled.
            </Text>
          </div>
        </div>
      </Card>

      {/* Action Buttons */}
      <div className="space-y-3">
        <Button
          color="blue"
          className="w-full py-3 text-base font-semibold"
          onClick={onNylasButtonClick}
        >
          Connect Calendar
        </Button>

        <div className="flex justify-between gap-3">
          <Button
            outline
            className="flex-1 py-3 text-base"
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            outline
            className="flex-1 py-3 text-base"
            onClick={handleSkip}
          >
            Skip for Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CalendarStep;
